import appCONST from './../../../constants/app.constants';

export const ENDPOINTS = {
    eurostarSearchUrl: '/eurostar/Search',
    eurostarFilterUrl: '/eurostar/Filter',
    eurostarSearchLocationUrl: '/staticdata/SearchEurostarStations',
    eurostarPreviousSearchUrl: '/UserSearchParameters/UserSearch/AllEuroStar',
    eurostarFrequentLocationsUrl: '/authorize/GetFrequentLocationsForEurostar',
    eurostarGetSearchRequestUrl: '/UserSearchParameters/UserSearch/GetFlightSearchRequestForEurostar',
};

export default function TrainsApiService(
    $http,
    sessionService
) {
    'ngInject';

            const flightsApi = {
                search,
                filter,
                searchLocation,
                getRules,
                getSearchRequestById,
                getFrequentFlights,
                getPreviousSearches,
            };

            return flightsApi;

            function search(request) {
                return $http.apiPOST(ENDPOINTS.eurostarSearchUrl, request, {timeout: appCONST.productSearchTimeout});
            }

            function filter(parameters) {
                return $http.apiPOST(ENDPOINTS.eurostarFilterUrl, parameters, {timeout: appCONST.productSearchTimeout});
            }

            function searchLocation(request) {
                return $http.apiGET(ENDPOINTS.eurostarSearchLocationUrl, request)
                    .then(({data}) => data);
            }

            function getRules(params) {
                const isReadOnlyMode = sessionService.getSessionItem('readOnlyMode');
                const anonymousLink = appCONST.serverUrl + '/api/flights/SearchRulesAnonymous';

                const requestData = {
                    FlightRecommendationId: params.recommendationId,
                    FareRecommendationId: params.fareId,
                    FlightGroupIds: params.flightGroups,
                    SearchId: params.searchId,
                    Travelers: {
                        Adult: params.adultCount,
                        Infant: params.infantCount,
                        Child: params.childCount,
                    },
                };

                const requestConfig = {
                    culture: params.culture,
                };

                return (isReadOnlyMode)
                    ? $http.post(anonymousLink, requestData, requestConfig)
                    : $http.apiPOST('/flights/SearchRules', requestData);
            }

            function getSearchRequestById(id) {
                const params = {
                    searchParamId: id,
                };

                return $http.apiGET(ENDPOINTS.eurostarGetSearchRequestUrl, {params});
            }

            function getFrequentFlights() {
                return $http.apiGET(ENDPOINTS.eurostarFrequentLocationsUrl, {noSpinner: true});
            }

            function getPreviousSearches(topResults, searchType) {
                const params = {
                    topResults,
                    searchType,
                };

                return $http.apiGET(ENDPOINTS.eurostarPreviousSearchUrl, {params});
            }
}



// WEBPACK FOOTER //
// ./src/app/modules/trains-base/services/trains-api-service.js